import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IOnChangeServiceRequestControlsActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/ServiceRequestActionParams";
import { checkRequiredValidationAction } from "./CheckRequiredValidationAction";

class OnChangeServiceRequestControlsAction extends BaseAction<IDefaultActionResult, IOnChangeServiceRequestControlsActionParams> {

    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: [],
            message: "",
            status: "fail"
        }

        try {
            const { formData, fieldId, value, additionalFields, fieldTitle } = this.params!

            const oldFields = { ...formData };
            oldFields[fieldId] = value;

            // If PROFILE field changed (DynamicForm only), also update NUMBER_OF_PASSENGERS field
            // Only for DynamicForm - GroupBookingForm handles this differently
            if (fieldTitle === "PROFILE") {
                const numberOfPassengersField = additionalFields.find(
                    (f) => f.title === "NUMBER_OF_PASSENGERS"
                );
                if (numberOfPassengersField) {
                    try {
                        const passengers = JSON.parse(value);
                        const totalWithoutInfants = Object.entries(passengers)
                            .filter(([passengerType]) => passengerType !== "infants")
                            .reduce((sum, [, count]) => sum + (count as number), 0);
                        oldFields[numberOfPassengersField.fieldId] = String(totalWithoutInfants);
                    } catch {
                        oldFields[numberOfPassengersField.fieldId] = "";
                    }
                }
            }

            //Check filed which is affect to the this current filed change.
            const filedConditions = additionalFields.filter((f) =>
                (f?.conditions || []).find((c) => c.when === fieldTitle)
            );
            if (filedConditions.length > 0) {
                filedConditions.forEach((filedCondition) => {
                    if (filedCondition?.conditions) {
                        const condition = filedCondition.conditions.every(
                            (condition) => oldFields[fieldId] === condition.match
                        );
                        if (!condition) {
                            delete oldFields[filedCondition.fieldId];
                        }
                    }
                });
            }
            updateRecoilState("serviceRequestFormDataAtom", oldFields)
            checkRequiredValidationAction.setParams({
                additionalFields,
                formData:oldFields,
                bookingId: "", // No need to used
                selectedCategoryAndSubCategory: { category: null, subCategory: null } // no need to used
            });
            await checkRequiredValidationAction.execute();
        } catch (error) {
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const onChangeServiceRequestControlsAction = new OnChangeServiceRequestControlsAction()